export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_FORMAT_WITHOUT_YEAR = 'd MMM';
export const DATE_FORMAT_ONLY_TIME = 'HH:mm';
export const DATE_FORMAT_DAY = 'EEE dd MMM';
